/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MenuOrderDiscount,
    MenuOrderDiscountFromJSON,
    MenuOrderDiscountFromJSONTyped,
    MenuOrderDiscountToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {Array<MenuOrderDiscount>}
     * @memberof InlineResponse20018
     */
    discounts: Array<MenuOrderDiscount>;
}

export function InlineResponse20018FromJSON(json: any): InlineResponse20018 {
    return InlineResponse20018FromJSONTyped(json, false);
}

export function InlineResponse20018FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20018 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discounts': ((json['discounts'] as Array<any>).map(MenuOrderDiscountFromJSON)),
    };
}

export function InlineResponse20018ToJSON(value?: InlineResponse20018 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discounts': ((value.discounts as Array<any>).map(MenuOrderDiscountToJSON)),
    };
}


